import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Header } from "@/components/Header";
import { KeyMetricsCards } from "@/components/analytics/KeyMetricsCards";
import { SalesOverviewChart } from "@/components/analytics/SalesOverviewChart";
import { FreelancerCommissionsChart } from "@/components/analytics/FreelancerCommissionsChart";
import { LeadConversionChart } from "@/components/analytics/LeadConversionChart";
import { RevenueByClientChart } from "@/components/analytics/RevenueByClientChart";
import { AnalyticsFilters, type AnalyticsFilters as FilterType } from "@/components/analytics/AnalyticsFilters";

const Index = () => {
  const navigate = useNavigate();
  const [userRole, setUserRole] = useState<string>("");
  const [filters, setFilters] = useState<FilterType>({
    dateRange: {
      from: new Date(new Date().setMonth(new Date().getMonth() - 11)),
      to: new Date(),
    },
    groupBy: "month",
  });

  useEffect(() => {
    const checkUser = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        navigate("/auth");
        return;
      }

      // Get user role
      const { data: profile } = await supabase
        .from('profiles')
        .select('role')
        .eq('id', session.user.id)
        .single();

      if (profile) {
        setUserRole(profile.role);
      }
    };
    checkUser();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="container mx-auto py-6">
        <div className="mb-6">
          <h1 className="text-3xl font-bold">Main Dashboard</h1>
          <p className="text-muted-foreground">
            {userRole === 'freelancer' 
              ? 'Track your assigned leads and performance'
              : 'Track your business performance'
            }
          </p>
        </div>
        
        <AnalyticsFilters onFiltersChange={setFilters} />
        
        <div className="space-y-6">
          <KeyMetricsCards 
            dateRange={filters.dateRange} 
            userRole={userRole}
          />
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <SalesOverviewChart 
              dateRange={filters.dateRange} 
              groupBy={filters.groupBy}
              userRole={userRole}
            />
            <RevenueByClientChart 
              dateRange={filters.dateRange} 
            />
            <FreelancerCommissionsChart 
              dateRange={filters.dateRange} 
              groupBy={filters.groupBy}
              userRole={userRole}
            />
            <LeadConversionChart 
              dateRange={filters.dateRange}
              userRole={userRole}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
